import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Song} from '../../api/types';

export interface LikedSongsState {
    songs: Record<string, Song>;
    order: string[];
}

const initialState: LikedSongsState = {
    songs: {},
    order: [],
};

export const likedSongsSlice = createSlice({
    name: 'likedSongs',
    initialState,
    reducers: {
        toggleLike(state, action: PayloadAction<Song>) {
            const song = action.payload;
            if (state.songs[song.id]) {
                delete state.songs[song.id];
                state.order = state.order.filter(id => id !== song.id);
            } else {
                state.songs[song.id] = song;
                state.order.unshift(song.id);
            }
        },
        removeLikedSong(state, action: PayloadAction<string>) {
            const id = action.payload;
            delete state.songs[id];
            state.order = state.order.filter(sid => sid !== id);
        },
        // Used by FirestoreUserDataSync to apply remote state. Excluded from
        // userDataSyncMiddleware to avoid echo loops.
        setAllLikedSongs(state, action: PayloadAction<{songs: Record<string, Song>; order: string[]}>) {
            state.songs = action.payload.songs;
            state.order = action.payload.order;
        },
    },
});

export const {toggleLike, removeLikedSong, setAllLikedSongs} = likedSongsSlice.actions;
export default likedSongsSlice.reducer;
